import React, { useState, useEffect } from "react";
import { createWorkOrderTask, updateWorkOrderTask } from "../api/WorkOrderTemplate";

function WorkOrderTaskModal({ task = {}, templateId, onClose, onSave }) {
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [priority, setPriority] = useState("Medium");
  const [dueDate, setDueDate] = useState("");
  const [assignedTo, setAssignedTo] = useState("");
  const [estimatedTime, setEstimatedTime] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  // Initialize state when the task changes
  useEffect(() => {
    setName(task.name || "");
    setDescription(task.description || "");
    setPriority(task.priority || "Medium");
    setDueDate(task.dueDate || "");
    setAssignedTo(task.assignedTo || "");
    setEstimatedTime(task.estimatedTime || "");
    setError("");

    console.log("Template ID in Task Modal:", templateId);
  }, [task, templateId]);

  const handleSubmit = async () => {
    if (!templateId) {
      setError("Template ID is missing. Cannot save task.");
      return;
    }

    const newTask = {
      name,
      description,
      priority,
      dueDate: dueDate || null,
      assignedTo,
      estimatedTime: estimatedTime ? Number(estimatedTime) : null,
    };

    try {
      setLoading(true);
      setError("");

      if (task.id) {
        const updatedTask = await updateWorkOrderTask(templateId, task.id, newTask);
        onSave(updatedTask);
      } else {
        const createdTask = await createWorkOrderTask(templateId, newTask);
        onSave(createdTask);
      }

      onClose();
    } catch (error) {
      console.error("Error saving work order task:", error);
      setError("Failed to save work order task. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-white w-full max-w-3xl rounded-lg shadow-lg">
        {/* Header */}
        <div className="p-4 border-b bg-gray-100">
          <h2 className="text-lg font-bold">{task.id ? "Edit Task" : "Add Task"}</h2>
        </div>

        {/* Content */}
        <div className="p-6 space-y-4">
          {error && <p className="text-red-500 text-sm">{error}</p>}

          <div>
            <label className="block text-sm font-medium">Task Name</label>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="w-full p-2 border rounded"
              placeholder="Enter task name"
            />
          </div>

          <div>
            <label className="block text-sm font-medium">Description</label>
            <textarea
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              className="w-full p-2 border rounded"
              placeholder="Enter task description"
            ></textarea>
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium">Priority</label>
              <select
                value={priority}
                onChange={(e) => setPriority(e.target.value)}
                className="w-full p-2 border rounded"
              >
                <option value="High">High</option>
                <option value="Medium">Medium</option>
                <option value="Low">Low</option>
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium">Due Date</label>
              <input
                type="date"
                value={dueDate}
                onChange={(e) => setDueDate(e.target.value)}
                className="w-full p-2 border rounded"
              />
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium">Assigned To</label>
            <input
              type="text"
              value={assignedTo}
              onChange={(e) => setAssignedTo(e.target.value)}
              className="w-full p-2 border rounded"
              placeholder="Enter assignee name"
            />
          </div>

          <div>
            <label className="block text-sm font-medium">Estimated Time (hours)</label>
            <input
              type="number"
              value={estimatedTime}
              onChange={(e) => setEstimatedTime(e.target.value)}
              className="w-full p-2 border rounded"
              placeholder="Enter estimated time"
            />
          </div>
        </div>

        {/* Footer */}
        <div className="p-4 border-t bg-gray-100 flex justify-end space-x-4">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-500 text-white rounded-md"
            disabled={loading}
          >
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            className="px-4 py-2 bg-blue-600 text-white rounded-md"
            disabled={loading}
          >
            {loading ? "Saving..." : "Save"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default WorkOrderTaskModal;